import { lazy, StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import "./styles.css";

function enableAutoOpen() {
  if (typeof Office === "undefined" || !Office.addin?.setStartupBehavior) {
    return;
  }
  try {
    Office.addin.setStartupBehavior(Office.StartupBehavior.load);
  } catch {
    // Silently ignore on unsupported platforms.
  }
}

if (typeof Office !== "undefined" && typeof Office.onReady === "function") {
  Office.onReady().then(enableAutoOpen).catch(() => {});
}

const App = lazy(() => import("./app/App").then((m) => ({ default: m.App })));
const DetailDialogPage = lazy(() =>
  import("./app/DetailDialogPage").then((m) => ({ default: m.DetailDialogPage }))
);
const PromptSuggestionsDialogPage = lazy(() =>
  import("./app/PromptSuggestionsDialogPage").then((m) => ({
    default: m.PromptSuggestionsDialogPage
  }))
);

const root = document.getElementById("root");
if (!root) {
  throw new Error("Missing #root");
}

const view = new URLSearchParams(window.location.search).get("view");
const isDetailDialog = view === "detail";
const isPromptSuggestionsDialog = view === "prompt-suggestions";

function DetailDialogFallback() {
  return (
    <div className="detail-dialog-page" role="status" aria-live="polite">
      <div className="detail-dialog-topbar">
        <div className="detail-dialog-title">Chi tiết</div>
      </div>
      <div className="detail-dialog-body">
        <p className="ai-search-detail-loading">Đang mở chi tiết…</p>
      </div>
    </div>
  );
}

createRoot(root).render(
  <StrictMode>
    <Suspense fallback={isDetailDialog ? <DetailDialogFallback /> : null}>
      {isDetailDialog ? (
        <DetailDialogPage />
      ) : isPromptSuggestionsDialog ? (
        <PromptSuggestionsDialogPage />
      ) : (
        <App />
      )}
    </Suspense>
  </StrictMode>
);
